import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';
import { ServicePayload } from '@nx-frontend/shared/types';

interface SendWorkspaceEventPayload extends ServicePayload {
  name: string;
  payload?: { [key: string]: unknown };
}

export const sendWorkspaceEvent = async ({
  name,
  payload,
  host,
  userId,
}: SendWorkspaceEventPayload): Promise<Record<string, never>> => {
  const response = await axiosClient.post(`${assertServiceHost(host)}/v1/events`, { name, payload }, { userId });
  return response.data;
};
